export const usPhoneDigits = (value) => {
  const digits = String(value || "").replace(/\D/g, "");
  return (
    digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits
  ).slice(0, 10);
};

export const usPhoneForApi = (value) => {
  const digits = usPhoneDigits(value);
  return digits.length === 10 ? `+1${digits}` : "";
};

export const tournamentDateLabel = (value) =>
  new Intl.DateTimeFormat("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  }).format(new Date(value));

export const tournamentStatusCopy = (registration) =>
  registration?.status === "Waitlisted"
    ? `Waitlist position ${registration.waitlistPosition}`
    : registration?.status;

export const money = (value) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(
    value || 0,
  );

export const dateLabel = (value) =>
  new Intl.DateTimeFormat("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
  }).format(new Date(`${value}T12:00:00`));

export const ordinal = (value) => {
  const number = Number(value);
  if (!number) return "—";
  const remainder = number % 100;
  const suffix = remainder >= 11 && remainder <= 13
    ? "th"
    : number % 10 === 1 ? "st" : number % 10 === 2 ? "nd" : number % 10 === 3 ? "rd" : "th";
  return `${number}${suffix}`;
};

export const rankLabel = (rank, total) => rank ? `#${rank} of ${total}` : "Not ranked yet";
